<div class="space-y-6 max-w-[1280px] mx-auto px-4 sm:px-6 md:px-8 py-8 min-h-screen bg-background font-sans" id="saved-view-root">
  
  <div class="loader-overlay flex justify-center py-10" *ngIf="loading">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>

  <ng-container *ngIf="!loading">
    <!-- Title Header -->
    <!-- Title Header -->
<div class="favorites-page-header">

  <div class="favorites-title-row">

    <!-- Back Button -->
    <button
      type="button"
      class="back-btn"
      (click)="goBack()"
      aria-label="Go back">

      <span class="material-symbols-outlined">
        arrow_back
      </span>

    </button>

    <!-- Title -->
    <h2 class="font-display font-bold text-2xl text-primary tracking-tight m-0">
      Shortlists & Collections
    </h2>

  </div>

  <!-- Description -->
  <p class="text-secondary text-sm m-0 mt-1 favorites-description">
    Organize and coordinate your premium candidate shortlists and saved search filters.
  </p>

</div>

    <!-- Subtab Switcher Pills -->
    <div class="flex border-b border-secondary/10 mt-6" id="saved-sub-navigation">
      <button
        (click)="activeSubTab = 'favorites'"
        class="px-6 py-3 font-semibold text-xs tracking-wide border-b-2 transition-all flex items-center gap-2 bg-transparent border-t-0 border-l-0 border-r-0"
        [ngClass]="activeSubTab === 'favorites' ? 'border-b-primary text-primary' : 'border-b-transparent text-secondary hover:text-primary'"
      >
        <span class="material-symbols-outlined text-lg fill-icon">stars</span>
        Favorite Profiles ({{ favoriteProfiles.length }})
      </button>
      <button
        (click)="activeSubTab = 'filters'"
        class="px-6 py-3 font-semibold text-xs tracking-wide border-b-2 transition-all flex items-center gap-2 bg-transparent border-t-0 border-l-0 border-r-0"
        [ngClass]="activeSubTab === 'filters' ? 'border-b-primary text-primary' : 'border-b-transparent text-secondary hover:text-primary'"
      >
        <span class="material-symbols-outlined text-lg">bookmark</span>
        Saved Filters ({{ savedFilters.length }})
      </button>
    </div>

    <!-- Favorites Subtab Container -->
    <div *ngIf="activeSubTab === 'favorites'" id="favorites-subtab-panel" class="animate-fadeIn mt-6">
      <div *ngIf="favoriteProfiles.length > 0; else emptyFavorites" class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div
          *ngFor="let fav of favoriteProfiles"
          class="rounded-3xl p-5 flex flex-col sm:flex-row gap-5 items-start transition-all relative group overflow-hidden"
          style="background: linear-gradient(145deg, #ffffff 0%, #fff4f6 100%); border: 1.5px solid rgba(176,30,62,0.22); box-shadow: 0 8px 24px -4px rgba(176,30,62,0.12);"
        >
          <!-- Top decorative accent strip -->
          <div class="absolute top-0 left-0 right-0 h-1" style="background: linear-gradient(90deg, #B01E3E 0%, #ff85a1 100%);"></div>

          <!-- Shortlisted Badge -->
          <div class="absolute top-3.5 right-4 flex items-center gap-1 px-2.5 py-0.5 rounded-full text-[10px] font-bold shadow-2xs"
            style="background: #fdf0f3; color: #B01E3E; border: 1px solid rgba(176,30,62,0.25);">
            <span class="material-symbols-outlined text-[13px] fill-icon">star</span>
            <span>Shortlisted</span>
          </div>

          <!-- Portrait circular clipping -->
          <div 
            (click)="viewProfile(fav.selected_profile_id)"
            class="h-20 w-20 rounded-full overflow-hidden shrink-0 cursor-pointer hover:scale-105 transition-transform shadow-md mt-1"
            style="border: 3px solid #fdf0f3; outline: 2px solid rgba(176,30,62,0.2);"
          >
            <ng-container *ngIf="base64Images[fav.selected_profile_id]; else defaultAvatar">
              <img [src]="'data:image/jpeg;base64,' + base64Images[fav.selected_profile_id]" class="h-full w-full object-cover" />
            </ng-container>
            <ng-template #defaultAvatar>
              <div class="h-full w-full flex items-center justify-center bg-surface-container-low text-on-surface-variant/30">
                <span class="material-symbols-outlined text-[40px]">person</span>
              </div>
            </ng-template>
          </div>

          <!-- Core contents -->
          <div class="flex-1 space-y-3 w-full">
            <div class="pr-20">
              <div class="flex items-center justify-between">
                <h4 
                  (click)="viewProfile(fav.selected_profile_id)"
                  class="font-display font-bold text-base text-primary hover:underline cursor-pointer flex items-center gap-1.5 m-0"
                >
                  {{ getMaskedName(fav) }}
                  <span class="text-emerald-500 material-symbols-outlined fill-icon text-xs">verified</span>
                </h4>
              </div>
              <p class="text-secondary text-[11px] font-medium m-0 mt-0.5">
                {{ getAge(fav.fullDetails?.basic_info?.date_of_birth || fav.basic_info?.date_of_birth) }} yrs • {{ fav.fullDetails?.personal_info?.height || '--' }} • {{ getProfession(fav) }} ({{ getLocationLine(fav) }})
              </p>
            </div>

            <!-- Shortlist Notes Textbox (Interactive custom user notes) -->
            <div class="p-3.5 rounded-2xl text-xs text-secondary/90 w-full relative transition-colors"
              style="background: rgba(255, 255, 255, 0.85); border: 1px dashed rgba(176,30,62,0.3); box-shadow: inset 0 2px 4px rgba(0,0,0,0.02);">
              <div class="flex justify-between items-center mb-1">
                <span class="text-[9px] uppercase tracking-wider font-mono font-bold text-primary flex items-center gap-1">
                  <span class="material-symbols-outlined text-[12px]">edit_note</span>
                  Personal Matchmaker Note
                </span>
                <button
                  *ngIf="editingNoteId !== fav.selected_profile_id; else saveNoteBtn"
                  (click)="startEditingNote(fav.selected_profile_id)"
                  class="text-primary hover:underline font-semibold text-[10px] bg-transparent border-0 cursor-pointer"
                >
                  Edit
                </button>
                <ng-template #saveNoteBtn>
                  <button
                    (click)="saveNote(fav.selected_profile_id)"
                    class="text-emerald-700 hover:underline font-bold text-[10px] bg-transparent border-0 cursor-pointer"
                  >
                    Save
                  </button>
                </ng-template>
              </div>
              
              <div *ngIf="editingNoteId === fav.selected_profile_id; else readNoteText">
                <textarea
                  [(ngModel)]="tempNotes[fav.selected_profile_id]"
                  [ngModelOptions]="{standalone: true}"
                  class="w-full bg-white border border-secondary/20 rounded p-1.5 text-xs focus:ring-1 focus:ring-primary outline-none mt-1"
                  rows="2"
                  placeholder="Type notes on custom conversations or horoscopic criteria..."
                ></textarea>
              </div>
              <ng-template #readNoteText>
                <p class="italic text-xs font-serif leading-relaxed px-0.5 text-secondary m-0 mt-1">
                  {{ profileNotes[fav.selected_profile_id] ? '"' + profileNotes[fav.selected_profile_id] + '"' : 'No custom notes added yet. Add private reflections here.' }}
                </p>
              </ng-template>
            </div>

            <!-- Foot buttons -->
            <div class="flex flex-wrap items-center gap-2 pt-2 border-t font-semibold text-xs" style="border-color: rgba(176,30,62,0.12);">
              <button
                (click)="viewProfile(fav.selected_profile_id)"
                class="px-3.5 py-1.5 bg-secondary-container hover:bg-primary-fixed text-primary rounded-lg flex items-center gap-1 transition-all border-0 cursor-pointer"
              >
                <span class="material-symbols-outlined text-sm">visibility</span>
                View Full ID
              </button>

              <button
                (click)="triggerInterest(fav.selected_profile_id, fav)"
                class="px-3.5 py-1.5 rounded-lg flex items-center gap-1 transition-all border-0 cursor-pointer"
                [ngClass]="fav.interestSent ? 'bg-rose-50 border border-rose-200 text-rose-600 cursor-not-allowed' : 'bg-primary text-white hover:bg-primary-container'"
                [disabled]="fav.interestSent"
              >
                <span class="material-symbols-outlined text-sm" [ngClass]="{'fill-icon': fav.interestSent}">favorite</span>
                {{ fav.interestSent ? 'Interest Sent' : 'Send Interest' }}
              </button>

              <button
                (click)="removeFavorite(fav.selected_profile_id)"
                class="px-2.5 py-1.5 border border-secondary/20 hover:border-rose-500 hover:text-rose-500 rounded-lg ml-auto transition-colors flex items-center justify-center text-secondary bg-white cursor-pointer shadow-2xs"
                title="Remove Shortlist"
              >
                <span class="material-symbols-outlined text-sm">delete</span>
              </button>
            </div>

          </div>

        </div>
      </div>

      <ng-template #emptyFavorites>
        <div class="bg-white rounded-3xl p-10 text-center border border-primary/5 shadow-sm max-w-sm mx-auto" id="no-favorites-panel">
          <div class="h-14 w-14 bg-primary-fixed/40 rounded-full flex items-center justify-center text-primary mx-auto mb-3">
            <span class="material-symbols-outlined text-2xl">star_outline</span>
          </div>
          <h4 class="font-display font-bold text-base text-primary m-0">Shortlist is Empty</h4>
          <p class="text-secondary text-xs mt-1.5 leading-relaxed">
            Start favoriting matches in the discover feed to view them side-by-side with private matchmaking memo logs here.
          </p>
          <button
            routerLink="/dashboard"
            class="mt-4 px-4 py-2 bg-primary text-white text-xs font-semibold rounded-xl hover:bg-primary-container transition-all border-0"
          >
            Go Discover Matches
          </button>
        </div>
      </ng-template>
    </div>

    <!-- Saved Filters Subtab Container -->
    <div *ngIf="activeSubTab === 'filters'" id="filters-subtab-panel" class="animate-fadeIn mt-6">
      <div *ngIf="savedFilters.length > 0; else emptyFilters" class="grid grid-cols-1 md:grid-cols-2 gap-5">
        <div
          *ngFor="let filter of savedFilters"
          class="rounded-3xl p-5 flex justify-between items-start gap-4 hover:shadow-md transition-all relative overflow-hidden group"
          style="background: linear-gradient(145deg, #ffffff 0%, #fff4f6 100%); border: 1.5px solid rgba(176,30,62,0.22); box-shadow: 0 8px 24px -4px rgba(176,30,62,0.12);"
        >
          <!-- Top decorative accent strip -->
          <div class="absolute top-0 left-0 right-0 h-1" style="background: linear-gradient(90deg, #B01E3E 0%, #ff85a1 100%);"></div>

          <div class="space-y-3 mt-1">
            <div>
              <h4 class="font-display font-bold text-sm text-primary flex items-center gap-1.5 m-0">
                <span class="material-symbols-outlined text-lg fill-icon">bookmark</span>
                Saved Filter Preset
              </h4>
            </div>
            
            <div class="text-xs text-secondary font-medium">
              Filter Name: <span class="text-primary font-bold">{{ filter.filter_name }}</span>
            </div>
          </div>

          <!-- Horizontal parameters action trigger -->
          <div class="flex items-center space-x-2 shrink-0 font-medium text-xs mt-1">
            <button
              (click)="runSavedFilterQuery(filter._id, filter.filter_name)"
              class="px-3.5 py-2 bg-primary hover:bg-primary-container text-white rounded-xl flex items-center gap-1 transition-all border-0 cursor-pointer shadow-sm"
            >
              <span class="material-symbols-outlined text-sm">pageview</span>
              Run
            </button>
            <button
              (click)="handleDeleteFilterConfirm(filter)"
              class="p-2 border border-secondary/20 hover:border-rose-500 hover:text-rose-500 rounded-xl text-secondary transition-colors bg-white cursor-pointer shadow-2xs"
              title="Clear Preset"
            >
              <span class="material-symbols-outlined text-sm">delete</span>
            </button>
          </div>

        </div>
      </div>

      <ng-template #emptyFilters>
        <div class="bg-white rounded-3xl p-10 text-center border border-primary/5 shadow-sm max-w-sm mx-auto" id="no-filters-panel">
          <div class="h-14 w-14 bg-primary-fixed/40 rounded-full flex items-center justify-center text-primary mx-auto mb-3">
            <span class="material-symbols-outlined text-2xl">bookmark_border</span>
          </div>
          <h4 class="font-display font-bold text-base text-primary m-0">No Saved Filters</h4>
          <p class="text-secondary text-xs mt-1.5 leading-relaxed">
            Refine parameters inside the search bar, click "Save Filter" in the discovering drawer, and review save configurations right here.
          </p>
          <button
            routerLink="/dashboard"
            class="mt-4 px-4 py-2 bg-primary text-white text-xs font-semibold rounded-xl hover:bg-primary-container transition-all border-0"
          >
            Launch Search Engine
          </button>
        </div>
      </ng-template>
    </div>

  </ng-container>
</div>
